// 过滤订购方式(subscribeMode)
export function filterSpec(val) {
  let str = "";
  switch (val) {
    case 0:
      str = "免费试用";
      break;
    case 1:
      str = "买断(ERP有效期内)";
      break;
    case 2:
      str = "按月订购";
      break;
    case 3:
      str = "按季订购";
      break;
    case 4:
      str = "半年订购";
      break;
    case 5:
      str = "按年订购";
      break;
    case 6:
      str = "充值";
      break;
    case 7:
      str = "价格面议";
      break;
    default:
      break;
  }
  return str;
}

// 过滤部署状态
export function getFormatStatus(val) {
  let str = "";
  switch (val) {
    case 0:
      str = "待部署";
      break;
    case 10:
      str = "已部署";
      break;
    case 20:
      str = "待关闭";
      break;
    case 30:
      str = "已关闭";
      break;
    case 40:
      str = "待发货";
      break;
    case 50:
      str = "已发货";
      break;
    default:
      break;
  }
  return str;
}

// 过滤硬件状态（因硬件可多次购买，显示发货状态不合适）
export function getHardwareStatus(val) {
  let obj = { str: "", color: "" };
  switch (val) {
    case 0:
      obj.str = "待部署";
      obj.color = "#FBDA0B";
      break;
    case 10:
      obj.str = "已部署";
      obj.color = "#1DB222";
      break;
    case 20:
    case 21:
      obj.str = "待关闭";
      obj.color = "#FFA900";
      break;
    case 30:
      obj.str = "已关闭";
      obj.color = "#999999";
      break;
    case 40:
      obj.str = "已订购";
      obj.color = "#4278FB";
      break;
    default:
      break;
  }
  return obj;
}

// 过滤部署状态颜色
export function getDeployStatusColor(val) {
  let str = "";
  switch (val) {
    case 0:
      str = "#FFA900";
      break;
    case 10:
      str = "#52C41A";
      break;
    case 20:
      str = "#449cf6"; ///待定
      break;
    case 30:
      str = "#8C8C8C";
      break;
    default:
      break;
  }
  return str;
}

// 过滤订单状态
export function filterBookStatus(val) {
  let str = "";
  switch (val) {
    case 0:
      str = "已取消";
      break;
    case 10:
      str = "待付款";
      break;
    case 20:
    case 30:
      str = "待部署";
      break;
    case 31:
      str = "待发货";
      break;
    case 32:
      str = "已发货";
      break;
    case 40:
      str = "已完成";
      break;
    default:
      break;
  }
  return str;
}

// 过滤订单状态颜色
export function filterBookStatusColor(val) {
  let str = "";
  switch (val) {
    case 0:
      str = "#8C8C8C";
      break;
    case 10:
      str = "#F87039";
      break;
    case 20:
    case 30:
      str = "#FFA900"; ///待定
      break;
    case 31:
      str = "#FFA900";
      break;
    case 32:
      str = "#52C41A";
      break;
    case 40:
      str = "#52C41A";
      break;
    default:
      break;
  }
  return str;
}

// 应用-返回状态码
export function backCode(val) {
  let codeStr = "";
  switch (val) {
    case 1001:
      codeStr = "参数无效";
      break;
    case 1002:
      codeStr = "参数为空";
      break;
    case 1003:
      codeStr = "参数类型错误";
      break;
    case 1004:
      codeStr = "参数缺失";
      break;
    default:
      break;
  }
  return codeStr;
}

// 过滤用户角色
export function filterRoles(val) {
  let roleStr = "";
  switch (parseInt(val)) {
    case 0:
      roleStr = "无";
      break;
    case 1:
      roleStr = "商户";
      break;
    case 2:
      roleStr = "商户管理员";
      break;
    case 11:
      roleStr = "普通用户";
      break;
    case 12:
      roleStr = "应用发布人";
      break;
    case 13:
      roleStr = "应用部署人";
      break;
    case 14:
      roleStr = "运营人";
      break;
    case 15:
      roleStr = "发货人";
      break;
    case 20:
      roleStr = "管理员";
      break;
    case 21:
      roleStr = "超级管理员";
      break;
    default:
      break;
  }
  return roleStr;
}

// 过滤申请状态
export function checkApplyType(val) {
  let obj = { str: "", color: "" };
  switch (parseInt(val)) {
    case 0:
      obj.str = "发布应用";
      obj.color = "#1DB222";
      break;
    case 1:
      obj.str = "更新应用";
      obj.color = "#4278FB";
      break;
    case 2:
      obj.str = "下架应用"
      obj.color = "#999999";
      break;
    default:
      break;
  }
  return obj;
}

// 过滤图片默认值(直接返图片url的)
export function getImgUrl(val) {
  if (val) {
    return val;
  }
  return require("@/assets/url_default.png");
}

// 应用发布页面（应用类型）
export function filterAppType(val) {
  let str = "";
  switch (parseInt(val)) {
    case 0:
      str = "可订购应用";
      break;
    case 1:
      str = "硬件";
      break;
    case 2:
      str = "预发布应用";
      break;
    case 3:
      str = "内置应用";
      break;
    case 4:
      str = "外部订购应用";
      break;
    default:
      break;
  }
  return str;
}

// 应用发布页面（规格状态）
export function filterSpecStatus(val) {
  let obj = { str: "", color: "" };
  switch (parseInt(val)) {
    case 0:
      obj.str = "（新增）";
      obj.color = "303133";
      break;
    case 1:
      obj.str = "（更新）";
      obj.color = "303133";
      break;
    case 2:
      obj.str = "（删除）";
      obj.color = "red";
      break;
    default:
      break;
  }
  return obj;
}

// 应用发布页面（审核状态）
export function getCheckStatue(val) {
  let obj = {text:'',color:''};
  switch (val) {
    case 0:
      obj.text = "编辑中";
      obj.color = '#1F5FFC'
      break;
    case 20:
      obj.text = "审核中";
      obj.color = '#FFA900'
      break;
    case 30:
      obj.text = "已完成";
      obj.color = '#1DB222'
      break;
    case 90:
      obj.text = "已驳回";
      obj.color = '#E10503'
      break;
    case 100:
      obj.text = "已取消";
      obj.color = '#999999'
      break;
    default:
      break;
  }
  return obj;
}


// 过滤订单状态(后台)
export function formatOrderStatus(val) {
  let str = {color:'',title:''};
  switch (parseInt(val)) {
    case 0:
      str.title = "已取消";
      str.color = '#999999'
      break;
    case 10:
      str.title = "待付款";
      str.color = '#36CFC9'
      break;
    case 20:
      str.title = "待自动部署";
      str.color = '#FFA900'
      break;
    case 30:
      str.title = "待人工部署";
      str.color = '#FBDA0B'
      break;
    case 31:
      str.title = "待发货";
      str.color = '#B47FED'
      break;
    case 32:
      str.title = "已发货";
      str.color = '#4278FB'
      break;
    case 40:
      str.title = "已完成";
      str.color = '#1DB222'
      break;
    case 50:
      str.title = "已发起退款";
      str.color = '#FFA900'
      break;
    case 60:
      str.title = "已退款";
      str.color = '#F56C6C'
      break;
    default:
      break;
  }
  return str;
}

// 通知计划页面提交状态
export function checkNoticeStatus(val) {
  let temp = {color:'',title:''};
  switch (val) {
    case 0:
      temp.title = "编辑中";
      temp.color = '#4278FB'
      break;
    case 10:
      temp.title = "已提交";
      temp.color = '#1DB222'
      break;
    case 20:
      temp.title = "已取消";
      temp.color = '#999999'
      break;
    default:
      break;
  }
  return temp;
}

// 通知计划页面发送状态
export function checkSendNoticeStatus(val) {
  let temp = {color:'', title:''};
  switch (val) {
    case 0:
      temp.title = "未发送";
      temp.color = '#FFA900'
      break;
    case 10:
      temp.title = "发送成功";
      temp.color = '#1DB222'
      break;
    case 20:
      temp.title = "发送失败";
      temp.color = '#E10503'
      break;
    default:
      break;
  }
  return temp;
}

// 通知计划页面发送状态
export function checkType(val) {
  let str = "";
  switch (parseInt(val)) {
    case 0:
      str = "全部";
      break;
    case 1:
      str = "前台商户";
      break;
    case 2:
      str = "后台管理员";
      break;
    case 3:
      str = "用户组";
      break;
    default:
      break;
  }
  return str;
}

// 吐槽类型替换
export function typeNameFilter(typeName, optionalName) {
  return optionalName ? `${typeName}/${optionalName}` : typeName
}

// token失效提示是否已存在
export default {
  TokenInvalidFlag: 0,
};

// 服务商列表
export const servicePro = [
  {label: '慧策', value: '慧策'},
  {label: '班牛', value: '班牛'},
  {label: '赤兔', value: '赤兔'},
  {label: '八爪云', value: '八爪云'},
  {label: '书链通', value: '书链通'},
  {label: '飞榴科技', value: '飞榴科技'},
]


export function creativeNeedStatus(val) {
  let str = "";
  switch (parseInt(val)) {
    case 0:
      str = "已提交";
      break;
    case 5:
      str = "已查阅";
      break;
    case 10:
      str = "已采纳";
      break;
    case 20:
      str = "已上线";
      break;
    default:
      break;
  }
  return str;
}

export function creativeCouponStatus(val) {
  let str = "";
  switch (parseInt(val)) {
    case 0:
      str = "未开始";
      break;
    case 1:
      str = "进行中";
      break;
    case 2:
      str = "已结束";
      break;
    case 3:
      str = "已关闭";
      break;
    default:
      break;
  }
  return str;
}

export function couponStatus(val) {
  let str = "";
  switch (parseInt(val)) {
    case 0:
      str = "待使用";
      break;
    case 1:
      str = "已使用";
      break;
    case 2:
      str = "已过期";
      break;
    default:
      break;
  }
  return str;
}

export function creativeNeedType(val) {
  let str = "";
  switch (parseInt(val)) {
    case 1:
      str = "市场新玩法";
      break;
    case 2:
      str = "解决痛点问题";
      break;
    default:
      break;
  }
  return str;
}